import { cn } from '@/lib/utils';

/**
 * Initials in a circle. Deliberately not `@radix-ui/react-avatar`.
 *
 * `OfficerIdentityDto` carries no photo, so the image-with-fallback state machine Radix
 * exists to solve is a problem this component does not have. `OfficerDto` does carry
 * `photoUrl`, which is why `src` is accepted — the officer LIST has photos, the signed-in
 * identity does not.
 */
const initialsOf = (name: string): string =>
  name
    .split(/\s+/)
    .map((part) => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

export type OfficerAvatarProps = {
  name: string;
  src?: string | undefined;
  className?: string;
};

export const OfficerAvatar = ({ name, src, className }: OfficerAvatarProps) => (
  <span
    className={cn(
      'inline-flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-full',
      'border border-border bg-secondary text-xs font-medium text-muted-foreground',
      className,
    )}
    // The initials are decorative: every place this renders shows the name as text
    // beside it or names the officer in the control's own accessible name.
    aria-hidden
  >
    {src ? <img src={src} alt="" className="size-full object-cover" /> : initialsOf(name)}
  </span>
);
